export function debounce(func: (...args: any[]) => void, wait: number) {
    let timeout: NodeJS.Timeout

    return function executedFunction(...args: any[]) {
        const later = () => {
            clearTimeout(timeout)
            func(...args)
        }

        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
    }
}

export function pluralize(word: string, count: number) {
    if (word === 'person') {
        return count === 0 || count > 1 ? 'people' : 'person'
    }

    // if the word ends in "s", "x", "z", "ch", or "sh", add "es"
    if (/(s|x|z|ch|sh)$/.test(word)) {
        return count === 1 ? word : `${word}es`
    }

    return count === 1 ? word : `${word}s`
}
